import { render, staticRenderFns } from "./batchAddProduct.vue?vue&type=template&id=4ed71b19&scoped=true"
import script from "./batchAddProduct.vue?vue&type=script&lang=js"
export * from "./batchAddProduct.vue?vue&type=script&lang=js"
import style0 from "./batchAddProduct.vue?vue&type=style&index=0&id=4ed71b19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed71b19",
  null
  
)

export default component.exports